import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Page',
    component: () => import('../views/Index.vue'),
    children: [
      {
        path: '',
        name: 'Index',
        component: () => import('../views/IndexInfo.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'teacher',
        name: 'Teacher',
        component: () => import('../views/UserList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'teacher/:user_id',
        name: 'TeacherDetail',
        component: () => import('../views/UserDetail.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('../views/UserList.vue'),
        meta: { requiresAuth: true }        
      },
      {
        path: 'admin/:user_id',
        name: 'AdminDetail',
        component: () => import('../views/UserDetail.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'room',
        name: 'Room',
        component: () => import('../views/RoomList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'pending',
        name: 'Pending',
        component: () => import('../views/SubscribeList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'approved',
        name: 'Approved',
        component: () => import('../views/SubscribeList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'mysubscribe',
        name: 'Mysubscribe',
        component: () => import('../views/MySubscribeList.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'email',
        name: 'Email',
        component: () => import('../views/GroupEmail.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'email/edit',
        name: 'EditEmail',
        component: () => import('../views/EmailEdit.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/forgetPwd',
    name: 'ForgetPwd',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/setPwd',
    name: 'SetPwd',
    component: () => import('../views/Login.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const islogin = store.state.islogin
  if (to.meta.requiresAuth) {
      if (islogin) {
          next()
      } else {
          next('/login')
      }
  } else {
      next()
  }
})

export default router
